import React from "react";
import { logo } from "../../assets/images";
import { RiArrowDropDownLine } from "react-icons/ri";
import { BiChevronRight, BiSearch } from "react-icons/bi";
import { Link } from "react-router-dom";

const Navbar: React.FC = () => {
  return (
    <div className="w-full bg-white sticky top-0 z-10 ">
      <div className="flex w-[90%] py-6 justify-between items-center mx-auto  ">
        <Link to="/">
          <div className="flex cursor-pointer items-center p-1 ">
            <img src={logo} alt="logo" className="w-9 h-9 lg:w-12 lg:h-12" />
            <h1 className=" hidden md:block text-[16px] lg:text-[24px] leading-7 font-Poppins text-midGreen uppercase  font-bold">
              ECOMOTO
            </h1>
          </div>
        </Link>
        <div className="relative hidden md:flex w-[50%]  ">
          <input
            type="text"
            placeholder="Search"
            className="w-[90%] p-3  text-sm text-gray-700 placeholder-gray-600 bg-[rgba(238,238,238,0.93)]  rounded-lg focus:outline-none focus:border-midGreen"
          />
          <BiSearch className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-600" />
        </div>
        <div className="flex gap-[15px] lg:gap-[34px] justify-center items-center ">
          <p className="text-white bg-midGreen border rounded-full text-[10px] lg:text-[16px] leading-6 font-Inter font-medium p-2">
            TO
          </p>
          <RiArrowDropDownLine className="text-midGreen text-[20px] lg:text-[30px]" />
          <button
            type="button"
            className="text-white text-[15px] lg:text-[20px] bg-midGreen p-3 flex justify-center items-center flex-shrink-0 border rounded-md "
          >
            Get Started
            <span>
              <BiChevronRight className="text-[15px] lg:text-[20px] text-white" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
